module.exports = __webpack_public_path__ + "img/der.582c7098.png";